import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"

import React, { Component } from "react"

/**
 * dewar - сосуд Дьюара.
 * 
 * onEditDewarClick(dewar) - запрос на редактирование сосуд Дьюара.
 * onCancelClick() - запрос отмены.
 */

class EditDewarDialog extends (Component) {

    constructor(props) {
        
        super(props)
        
        this.state = {
            code: "",
            dialog: undefined,
        }

    }

    componentDidMount() {
        this.setState({
            code: this.props.dewar.code,
        })
    }

    isReady() {
        if (this.state.code === this.props.dewar.code) {
            return false
        }
        if (this.state.code === "") {
            return false
        }
        return true
    }

    render() {

        if (this.state.dialog) {
            return this.state.dialog
        }

        return <Dialog
            open = {true}
            fullWidth = {true}        
        >

            <DialogTitle>
				Редактировать сосуд Дьюара
			</DialogTitle>

            <DialogContent style = {{display: "flex", flexDirection: "column"}}>
                
                <TextField
					value = {this.state.code}
					label = "Код сосуда Дьюара"
					margin = "normal"
					onChange = {e => {
						e.preventDefault()
						this.setState({code: e.target.value})
					}}                    
                />

            </DialogContent>

            <DialogActions>

                <Button
                    disabled = {!this.isReady()}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onEditDewarClick === "function") {
                            this.props.onEditDewarClick({
                                id: this.props.dewar.id,
                                code: this.state.code,
                            })
                        }
                    }}
                >Сохранить</Button>

                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

            </DialogActions>

        </Dialog>

    }

}

export default EditDewarDialog